import { getTestIds } from 'seagull/utils/TestIds';
export const GetCadenceTimesDropdownTID = (parentTestId)=>getTestIds(parentTestId);
